import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { lmwAuthLazyLoadedState } from '../../../auth-process/common/routing/route-locales/app-routes';
import { signInLazyLoaded } from '../../../auth-process/sign-in/routing/route-locales/sign-in-routes';
import { registrationLazyLoaded } from '../../../auth-process/registration/routing/route-locales/registration-routes';

@Component({
  selector: 'lmw-base-mobile-register-sign-in-bar',
  templateUrl: './mobile-register-sign-in-bar.component.html'
})
export class MobileRegisterSignInBarComponent implements OnInit {

  @Input() language?: string = "en";

  public signInLinkPath = `/${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}`;
  public registrationLinkPath = `/${lmwAuthLazyLoadedState.path}/${registrationLazyLoaded.path}`;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

}
